export default class SelectOption {
    public id: string | number;
    public text: string;
    public parent?: string | number;
    public active?: boolean;
    public disabled?: boolean;
    constructor(id: string | number, text: string, parent?: string | number) {
        this.id = id;
        this.text = text;
        this.parent = parent;
        this.active = true;
        this.disabled = false;
    }
}
export class SelectOptionWithData<T> extends SelectOption {
    public data: T;

    constructor(id: string | number, text: string, data: T) {
        super(id, text);
        this.data = data;
    }
}
